import { render, staticRenderFns } from "./RechargeResult.vue?vue&type=template&id=3b53385f&"
import script from "./RechargeResult.vue?vue&type=script&lang=js&"
export * from "./RechargeResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports